import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Papa from 'papaparse';
import Const from '../../util/Constants';
import Util from '../../util/Util';
import FilterPannel from '../filter/FilterPannel';
import SalesOrderAPI from '../../api/SalesOrderAPI';

class FixedSalesOrderReport extends React.Component {
  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model);
    this.salesOrder = this.model.sales_order;
    this.users = this.model.user.options;
    this.progress = this.model.lead.fields.progress.options;
    this.probability = this.model.probability.options;
    this.source = this.model.source.options;
    this.salesType = this.salesOrder.fields.sales_type.options;
    this.propertyType = this.salesOrder.fields.property_type.options;
    this.currency = this.model.currency.options;
    this.project = this.model.project.options;
    this.city = reactLocalStorage.getObject(Const.Cities);
    this.states = reactLocalStorage.getObject(Const.States);
    this.country = reactLocalStorage.getObject(Const.Countries);
    this.products = reactLocalStorage.getObject(Const.Products);
    this.complete = [{ id: 1, name: 'Yes' }, { id: 2, name: 'No' }];

    this.filters = [];
    this.state = {
      inApiCall: false,
      isFilterOpen: true,
    };
  }

  handleCsv = async () => {
    this.setState({ inApiCall: true });
    SalesOrderAPI.getFixedSalesOrderReportList(this.filters, this.onReceived, this.onFail);
  };

  onReceived = (response) => {
    try {
      if (response && Array.isArray(response)) {
        response.map((obj) => {
          Object.keys(obj).forEach(key => {
            if (typeof obj[key] === 'string' && obj[key].indexOf(Const.Opt) !== -1) {
              obj[key] = obj[key].split(Const.Opt).join("");
            }
            if (obj[key] === null || obj[key] === '~~' || obj[key] === '') {
              obj[key] = '-';
            }
          });
          obj.progress = this.progress.find((pro) => pro.value === obj?.progress)?.label;
          obj.project = this.project.find((pro) => pro.value === obj?.project)?.label;
          obj.lead_source = this.source.find((pro) => pro.value === obj?.lead_source)?.label;
          obj.source = this.source.find((pro) => pro.value === obj?.source)?.label;
          obj.sales_type = this.salesType.find((pro) => pro.value === obj?.sales_type)?.label;
          obj.property_type = this.propertyType.find((pro) => pro.value === obj?.property_type)?.label;
          obj.probability = this.probability.find((pro) => pro.value === obj?.probability)?.label;
          obj.currency = this.currency.find((pro) => pro.value === obj?.currency)?.label;
          obj.responsible_person = this.users.find((pro) => pro.value === obj.responsible_person)?.name;
          obj.sales_person = this.users.find((pro) => pro.value === obj.sales_person)?.name;
          obj.start_date = Util.serverStringToDisplayDateTime(obj.start_date);//moment(obj.start_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.end_date = Util.serverStringToDisplayDateTime(obj.start_date); //moment(obj.end_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.enquiry_date = Util.serverStringToDisplayDateTime(obj.enquiry_date); //moment(obj.end_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.created_date = Util.serverStringToDisplayDateTime(obj.created_date); // moment(obj.enquiry_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.updated_date = Util.serverStringToDisplayDateTime(obj.updated_date); //moment(obj.updated_date).local().format('DD-MM-YYYY HH:mm:ss');
          obj.created_by = this.users.find((pro) => pro.value === obj.created_by)?.name;
          obj.updated_by = this.users.find((pro) => pro.value === obj.updated_by)?.name;
          return obj;
        });
        this.generateCSV(response);
      } else {
        throw new Error("Invalid data format from API");
      }
    } catch (error) {
      this.onFail(error);
    }
  };

  generateCSV = (data) => {
    try {
      const csv = Papa.unparse(data, { header: true });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'BookingReport.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      Util.showNotification('Successful', 'Booking Report Downloaded successfully', 'success');

    } catch (error) {
      console.error("Error generating CSV:", error);
      Util.showError("Failed to generate CSV file");
    } finally {
      this.setState({ inApiCall: false });
    }
  };

  onFail = (error) => {
    this.setState({ inApiCall: false });
    console.error("API call failed:", error);
    Util.showError("Something Went Wrong");
  };

  toggleFilter = () => {
    this.setState((prevState) => ({ isFilterOpen: !prevState.isFilterOpen }));
  };

  closeFilter = () => {
    this.setState({ isFilterOpen: false });
  };

  onFilterChange = (filters) => {
    this.filters = filters;
    Util.showNotification('Successful', 'Filter Applied successfully', 'success');
  };

  render() {
    if (!this.salesOrder || !this.salesOrder.fields) return null;

    return (
      <div style={{ padding: '20px', backgroundColor: '#f9f9f9', textAlign: 'center' }}>
        {/* Heading and Buttons in One Line */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
          <h1 style={{ margin: '0', color: '#333' }}>Booking Report</h1>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px', marginBottom: '20px' }}>
            {/* Filter Button */}
            {/* Download CSV Button */}
            <button
              onClick={this.handleCsv}
              disabled={!this.filters}
              style={{
                padding: '10px 20px',
                backgroundColor: this.state.inApiCall ? '#cccccc' : '#28a745',
                color: '#ffffff',
                border: 'none',
                borderRadius: '5px',
                cursor: this.state.inApiCall ? 'not-allowed' : 'pointer',
                fontSize: '14px',
              }}
            >
              {this.state.inApiCall ? 'Preparing CSV...' : 'Download Report'}
            </button>
          </div>
        </div>

        {/* Filter Panel */}
        {this.state.isFilterOpen && (
          <div style={{ padding: '20px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '5px' }}>
            <FilterPannel
              filters={this.filters}
              fields={this.salesOrder.fields}
              onFilterChange={this.onFilterChange}
              closeFilter={this.closeFilter}
              isFilterOpen={this.state.isFilterOpen}
            />
          </div>
        )}
      </div>
    );
  }
}

export default FixedSalesOrderReport;
